import { render } from "./SectionDnaRepair2.vue?vue&type=template&id=2688b04a"
import script from "./SectionDnaRepair2.vue?vue&type=script&lang=js"
export * from "./SectionDnaRepair2.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__